var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "min-h-screen flex sm:justify-center pt-6 sm:pt-0 overflow-hidden",
    },
    [
      _c("v-container", { staticClass: "flex justify-center align-center" }, [
        _c(
          "div",
          { class: [_vm.$vuetify.breakpoint.xs ? null : "upper-third"] },
          [
            _c(
              "div",
              { staticClass: "flex justify-center" },
              [
                _c("v-img", {
                  staticClass: "mx-4",
                  attrs: {
                    src: "/musicologie-wordmark.webp",
                    "max-width": "200",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex-col" },
              [
                _c("lottie-player", {
                  staticStyle: { width: "inherit", height: "300px" },
                  attrs: {
                    src: "https://assets3.lottiefiles.com/packages/lf20_no08B3.json",
                    background: "transparent",
                    speed: "1",
                    loop: "",
                    autoplay: "",
                  },
                }),
                _vm._v(" "),
                _c(
                  "v-card-title",
                  { staticClass: "soli-grey justify-center" },
                  [_vm._v("Awesome, you’re registered!")]
                ),
                _vm._v(" "),
                _c(
                  "v-card-subtitle",
                  {
                    staticClass: "soli-grey",
                    staticStyle: {
                      "text-align": "center",
                      "white-space": "pre-line",
                    },
                  },
                  [
                    _vm._v(
                      "We’ll send more details as the day gets closer. Contact\n                    "
                    ),
                    _c(
                      "a",
                      {
                        staticClass: "soli-blue-text",
                        staticStyle: { "white-space": "nowrap" },
                        attrs: { href: "mailto:justin@musicologie.com" },
                      },
                      [
                        _vm._v(
                          "\n                        justin@musicologie.com\n                    "
                        ),
                      ]
                    ),
                    _vm._v("\n                    with questions."),
                  ]
                ),
                _vm._v(" "),
                _c("SoliBtn", {
                  staticClass: "justify-center w-full",
                  attrs: {
                    text: "Return Home",
                    href: _vm.route("login"),
                    gradient: "gradient-blue",
                  },
                }),
              ],
              1
            ),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }